import { Currency } from './orders'

export enum PlanPeriodUnit {
  Day = 'day',
  Month = 'month',
}

export interface PlanPrice {
  id: number
  amount: number
  currency: Currency
}

export interface Plan {
  id: number
  name: string | Record<string, string>
  description: string | Record<string, string>
  period: number
  period_unit: PlanPeriodUnit
  prices: PlanPrice[]
  features: string[]
  is_visible: boolean
  is_once_per_user: boolean
  was_used_by_user?: boolean
}

export interface Subscription {
  id: number
  status: number
  start_at: string
  ends_at: string
  cancelled_at: string | null
  next_charge_at: string | null
  subscription_plan: Plan
}

export enum SubscriptionTicketStatus {
  Created = 0,
  Activated = 1,
}

export interface TicketData {
  id: number
  name: string
  subtitle: string | null
  paid: boolean
  upgradable: boolean
  event_id: number
}

// tickets that user gets after buying subscription
export interface SubscriptionTicket {
  id: number
  event_id: number
  status: SubscriptionTicketStatus
  subscription_id: number
  ticket_id: number
  user_id: number
}

export interface SubscriptionPaymentData {
  redirect_url?: string
  sub_id?: string
  activated?: boolean
}
